
document.addEventListener('DOMContentLoaded', () => {
  const stateMap = new WeakMap();
  let activeOverlay = null;

  const formatMoney = (value) => {
    try {
      if (window.Shopify?.currency?.active) {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(value / 100);
      }
    } catch (error) {}
    return (value / 100).toFixed(2);
  };

  const formatVariantLabel = (value = '') => String(value)
    .replace(/[-_]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const getState = (overlay) => {
    if (!stateMap.has(overlay)) {
      stateMap.set(overlay, {
        product: null,
        images: [],
        currentImage: 0,
        selectedVariant: null
      });
    }
    return stateMap.get(overlay);
  };

  const closeOverlay = (overlay) => {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (activeOverlay === overlay) activeOverlay = null;
  };

  const updateMainImage = (overlay, index) => {
    const state = getState(overlay);
    const image = overlay.querySelector('.qv-image');
    if (!image || !state.images.length) return;
    state.currentImage = index;
    image.src = state.images[index];
  };

  const selectVariant = (overlay, variant) => {
    const state = getState(overlay);
    state.selectedVariant = variant;

    const price = overlay.querySelector('.qv-price');
    const stockText = overlay.querySelector('.qv-stock-text');
    const stockFill = overlay.querySelector('.qv-stock-fill');
    const image = overlay.querySelector('.qv-image');

    if (price) price.textContent = formatMoney(variant.price || 0);

    if (stockText && stockFill) {
      stockText.textContent = variant.available ? 'In Stock' : 'Out Of Stock';
      stockFill.style.width = variant.available ? '85%' : '15%';
    }

    if (variant?.featured_image?.src && image) {
      image.src = variant.featured_image.src;
    }
  };

  const hydrateModal = (overlay, product) => {
    const state = getState(overlay);
    const title = overlay.querySelector('.qv-title');
    const vendor = overlay.querySelector('.qv-vendor');
    const type = overlay.querySelector('.qv-type');
    const description = overlay.querySelector('.qv-short-description');
    const thumbs = overlay.querySelector('.qv-thumbs');
    const variantsWrap = overlay.querySelector('.qv-variants');
    const variantArea = overlay.querySelector('.qv-variant-area');
    const viewFull = overlay.querySelector('.qv-view-full');
    const qtyInput = overlay.querySelector('.qv-qty');
    const stockWrap = overlay.querySelector('.qv-stock-wrap');

    state.product = product;
    state.images = Array.isArray(product.images) ? product.images : [];
    state.currentImage = 0;
    state.selectedVariant = null;

    if (title) title.textContent = product.title || '';
    if (vendor) vendor.textContent = product.vendor || '';
    if (type) type.textContent = product.type || '';
    if (description) {
      description.textContent = product.description
        ? product.description.replace(/<[^>]+>/g, '').substring(0, 180)
        : '';
    }

    if (viewFull) viewFull.href = `/products/${product.handle}`;

    if (thumbs) {
      thumbs.innerHTML = '';
      if (state.images.length) {
        const image = overlay.querySelector('.qv-image');
        if (image) image.src = state.images[0];

        state.images.forEach((src, index) => {
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'qv-thumb';
          thumb.innerHTML = `<img src="${src}" alt="">`;
          thumb.addEventListener('click', () => updateMainImage(overlay, index));
          thumbs.appendChild(thumb);
        });
      }
    }

    if (variantsWrap) variantsWrap.innerHTML = '';

    const variants = (product.variants || []).filter((variant) => variant.title !== 'Default Title');

    if (variants.length && variantsWrap && variantArea) {
      variantArea.style.display = 'block';
      variants.forEach((variant, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'qv-variant' + (index === 0 ? ' active' : '');
        button.textContent = formatVariantLabel(variant.title);
        button.addEventListener('click', () => {
          variantsWrap.querySelectorAll('.qv-variant').forEach((node) => node.classList.remove('active'));
          button.classList.add('active');
          selectVariant(overlay, variant);
        });
        variantsWrap.appendChild(button);
      });
      selectVariant(overlay, variants[0]);
    } else {
      if (variantArea) variantArea.style.display = 'none';
      if (product.variants?.[0]) selectVariant(overlay, product.variants[0]);
    }

    if (qtyInput) qtyInput.value = 1;
    if (stockWrap) stockWrap.hidden = false;
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.ppc-btn, .ppc-mobile-btn');
    if (trigger) {
      const section = trigger.closest('.ppc-v8');
      const overlay = section?.querySelector('.qv-overlay');
      const handle = trigger.dataset.product;
      if (!overlay || !handle) return;

      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error(`Failed to load product ${handle}`);
        const product = await response.json();

        hydrateModal(overlay, product);
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        activeOverlay = overlay;
      } catch (error) {
        console.error('Quick View Error:', error);
      }
      return;
    }

    const closeBtn = event.target.closest('.qv-close');
    if (closeBtn) {
      closeOverlay(closeBtn.closest('.qv-overlay'));
      return;
    }

    const modal = event.target.closest('.qv-overlay');
    if (modal && event.target === modal) {
      closeOverlay(modal);
      return;
    }

    const prevBtn = event.target.closest('.qv-img-prev');
    if (prevBtn) {
      const overlay = prevBtn.closest('.qv-overlay');
      const state = getState(overlay);
      if (!state.images.length) return;
      const nextIndex = state.currentImage === 0 ? state.images.length - 1 : state.currentImage - 1;
      updateMainImage(overlay, nextIndex);
      return;
    }

    const nextImageBtn = event.target.closest('.qv-img-next');
    if (nextImageBtn) {
      const overlay = nextImageBtn.closest('.qv-overlay');
      const state = getState(overlay);
      if (!state.images.length) return;
      const nextIndex = state.currentImage === state.images.length - 1 ? 0 : state.currentImage + 1;
      updateMainImage(overlay, nextIndex);
      return;
    }

    const minus = event.target.closest('.qv-minus');
    if (minus) {
      const overlay = minus.closest('.qv-overlay');
      const qtyInput = overlay?.querySelector('.qv-qty');
      if (!qtyInput) return;
      const qty = parseInt(qtyInput.value, 10) || 1;
      if (qty > 1) qtyInput.value = qty - 1;
      return;
    }

    const plus = event.target.closest('.qv-plus');
    if (plus) {
      const overlay = plus.closest('.qv-overlay');
      const qtyInput = overlay?.querySelector('.qv-qty');
      if (!qtyInput) return;
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      return;
    }

const addCartBtn = event.target.closest('.qv-add-cart');
if (addCartBtn) {
  const overlay = addCartBtn.closest('.qv-overlay');
  const state = getState(overlay);
  if (!state.selectedVariant) return;

  const qtyInput = overlay.querySelector('.qv-qty');
  const quantity = parseInt(qtyInput?.value, 10) || 1;

  const setLoading = (loading) => {
    addCartBtn.classList.toggle('is-loading', loading);
    addCartBtn.disabled = loading;
    addCartBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  try {
    setLoading(true);

    if (window.Helm?.cart?.add) {
      await window.Helm.cart.add(state.selectedVariant.id, { quantity });
    } else {
      throw new Error('Cart API is not available');
    }

    closeOverlay(overlay);
  } catch (error) {
    console.error('Quick View Add To Cart Error:', error);
  } finally {
    setLoading(false);
  }

  return;
}
    const buyNowBtn = event.target.closest('.qv-buy-now');
    if (buyNowBtn) {
      const overlay = buyNowBtn.closest('.qv-overlay');
      const state = getState(overlay);
      if (!state.selectedVariant) return;
      const qtyInput = overlay.querySelector('.qv-qty');
      const qty = parseInt(qtyInput?.value, 10) || 1;
      window.location.href = `/cart/${state.selectedVariant.id}:${qty}`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeOverlay) {
      closeOverlay(activeOverlay);
    }
  });
});
